// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from '/home/jenkins/workspace/fe-storemap-h5-online/relx-map/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@/Loading';

export function getRoutes() {
  const routes = [
  {
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__index' */'@/layouts/index.tsx'), loading: LoadingComponent}),
    "routes": [
      {
        "path": "/Comments/HeaderFilter",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Comments__HeaderFilter' */'@/pages/Comments/HeaderFilter.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Comments",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Comments__index' */'@/pages/Comments/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Consultant",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Consultant__index' */'@/pages/Consultant/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Detail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Detail__index' */'@/pages/Detail/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Feedback",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Feedback__index' */'@/pages/Feedback/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Report",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Report__index' */'@/pages/Report/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Reviews",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Reviews__index' */'@/pages/Reviews/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Rule/UserAgreement",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Rule__UserAgreement__index' */'@/pages/Rule/UserAgreement/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/SupplyBackUp",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SupplyBackUp__index' */'@/pages/SupplyBackUp/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__index' */'@/pages/index.tsx'), loading: LoadingComponent})
      }
    ]
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
